// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a3bfcd73","698":"6f516278"}[chunkId] + ".chunk.js";
};